module.exports = __webpack_public_path__ + "de77a722/img/google.68f3823e.svg";